/**
 * Realistic ping-pong bat geometry: round rubber face + short flared handle.
 * Shared by role crest, club placeholder, and mono icons.
 * Reference viewBox: 0 0 64 64
 */
export function PingPongPaddlePaths({
  mode = "color", // "color" | "mono"
  transform = "",
}) {
  const isMono = mode === "mono";
  const wood = isMono ? "currentColor" : "#E8C49A";
  const handle = isMono ? "currentColor" : "#D4A574";
  const rubber = isMono ? "currentColor" : "#C62828";

  return (
    <g transform={transform || undefined}>
      {isMono ? (
        <>
          {/* Single silhouette: round head + flared handle */}
          <path
            d="M28 8.6
               c-9.35 0-16.9 7.55-16.9 16.9
               0 7.05 4.35 13.1 10.55 15.55
               -.15 2.7-.05 5.85.4 8.5
               .3 1.7.85 3.35 1.85 4.45
               .65.7 1.55 1.15 2.95 1.15
               1.4 0 2.3-.45 2.95-1.15
               1-1.1 1.55-2.75 1.85-4.45
               .45-2.65.55-5.8.4-8.5
               6.2-2.45 10.55-8.5 10.55-15.55
               0-9.35-7.55-16.9-16.9-16.9z"
            fill="currentColor"
          />
          {/* Face rim cue */}
          <ellipse
            cx="28"
            cy="25.5"
            rx="11.2"
            ry="11.6"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.5"
            opacity="0.22"
          />
          <path
            d="M26.2 43.6c-.05 1.9.05 4 .35 5.7"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.2"
            strokeLinecap="round"
            opacity="0.22"
          />
        </>
      ) : (
        <>
          {/* Wood blade rim — nearly circular like a real TT head */}
          <ellipse cx="28" cy="25.5" rx="16.4" ry="16.8" fill={wood} />

          {/* Rubber sheet (inset) */}
          <ellipse cx="28" cy="25.5" rx="13.7" ry="14.1" fill={rubber} />
          <ellipse cx="28" cy="25.5" rx="11.4" ry="11.8" fill="#8E0000" opacity="0.28" />
          <ellipse cx="24" cy="21" rx="5.4" ry="4.6" fill="#fff" opacity="0.16" />

          {/* Throat into handle */}
          <path
            d="M22.4 39.6c1.9 1.25 4.6 1.9 5.6 1.9s3.7-.65 5.6-1.9c-1.15 2.35-3.05 3.85-5.6 3.85s-4.45-1.5-5.6-3.85z"
            fill={wood}
          />

          {/* Classic flared / anatomic handle — short & stubby vs tennis */}
          <path
            d="M24.4 40.85
               c-.2 2.55-.1 5.55.35 8.15
               .25 1.5.75 3 1.65 4.05
               .55.65 1.35 1.1 2.6 1.1
               1.25 0 2.05-.45 2.6-1.1
               .9-1.05 1.4-2.55 1.65-4.05
               .45-2.6.55-5.6.35-8.15
               -1.4.75-3.2 1.15-4.6 1.15
               -1.4 0-3.2-.4-4.6-1.15z"
            fill={handle}
          />
          <path
            d="M26.05 42.1c-.1 2.2 0 4.8.35 7 .2 1.15.55 2.25 1.1 3"
            fill="none"
            stroke="#F3E0C4"
            strokeWidth="1.35"
            strokeLinecap="round"
            opacity="0.75"
          />
        </>
      )}
    </g>
  );
}

export function PingPongBall({ cx = 48, cy = 14, r = 5.4, mode = "color" }) {
  const isMono = mode === "mono";
  return (
    <g>
      <circle cx={cx} cy={cy} r={r} fill={isMono ? "currentColor" : "#FF8A3D"} />
      {isMono ? (
        <circle
          cx={cx - r * 0.28}
          cy={cy - r * 0.3}
          r={r * 0.28}
          fill="currentColor"
          opacity="0.35"
        />
      ) : (
        <>
          <circle cx={cx - 1.4} cy={cy - 1.5} r={r * 0.32} fill="#fff" opacity="0.45" />
          <circle
            cx={cx}
            cy={cy}
            r={r - 0.55}
            fill="none"
            stroke="#E65100"
            strokeWidth="0.7"
            opacity="0.35"
          />
        </>
      )}
    </g>
  );
}
